import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modal: null,
  modalProps: {},
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openModal(state, action) {
      state.modal = action.payload.name;
      state.modalProps = action.payload.props || {};
    },
    closeModal(state) {
      state.modal = null;
      state.modalProps = {};
    },
  },
});

export const { openModal, closeModal } = uiSlice.actions;
export const selectModal = (state) => state.ui.modal;
export const selectModalProps = (state) => state.ui.modalProps;
export default uiSlice.reducer;
